import React from "react";

import classes from "./EquipmentSetsIndex.module.scss";

const EquipmentSetsIndex = () => {
  return (
    <div className={classes.placeholder}>
      <p>Select an equipment set on the left to review drawable files and missing assets.</p>
    </div>
  );
};

EquipmentSetsIndex.displayName = "EquipmentSetsIndex";

export default EquipmentSetsIndex;
